import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAddressBook } from "app/auth/models/address-book";

@Component({
  selector: "app-address-book",
  templateUrl: "./address-book.component.html",
  styleUrls: ["./address-book.component.scss"],
})
export class AddressBookComponent implements OnInit {
  public addressBook: IAddressBook[] = [];
  public filteredList: IAddressBook[] = [];
  public searchKey: string = "";
  public searchFigure: number = 0;
  public contentHeader: IContentHeader;

  constructor(
    private _userService: UserService,
    public _userFigureService: UserFigureService,
    private _utilsService: UtilsService,
  ) {
    this._utilsService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.TITLES.EMPLOYEE_ADDRESS_BOOK,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.TITLES.EMPLOYEE_ADDRESS_BOOK,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this._utilsService.showLoading();
    this.addressBook = await this._userService.addressBook().then((result) => {
      this._utilsService.hideLoading();
      return result;
    });
    await this.filterUsers();
  }

  filterUsers() {
    this.filteredList = JSON.parse(JSON.stringify(this.addressBook));

    if (this.searchFigure === null) {
      this.searchFigure = 0;
    }

    if (this.searchKey.length > 3) {
      const key: string = this.searchKey.toLowerCase();
      this.filteredList = this.filteredList.filter((user) => user.complete_name.toLowerCase().includes(key));
    }

    if (this.searchFigure > 0) {
      this.filteredList = this.filteredList.filter((user) => user.figure_id === this.searchFigure);
    }
  }

  searchByFigure(figure_id: number) {
    this.searchFigure = figure_id;
    this.filterUsers();
  }
}
